'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toDashCase = exports.toDashCase = function toDashCase(str) {
  return str.replace(/([A-Z])/g, function ($1) {
    return '-' + $1.toLowerCase();
  });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rmwc/base/utils/to-dash-case.js
// module id = 449
// module chunks = 0